import React, { useState, useCallback } from "react";
import crStyles from "../customerReservation/crStyles";
import styles from "../tradeIn/TradeIn.module.scss";
import sharedStyles from "../customerOrderDetail/orderDetailsNewVersion/OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { withTranslation } from "react-i18next";
import {
  IS_USA_MARKET,
  OFFLINE_TRADE_IN_MARKETS,
  ONLINE_TRADE_IN_MARKETS,
} from "../../utils/EmpUtil";
import HasPermissionTo from "../../common/HasPermissionTo";
import { FINANCED, LEASED, OWNED } from "../../common/Constants";
import OfflineTradeIn from "./offline/OfflineTradeIn";
import OnlineTradeIn from "./online/OnlineTradeIn";
import { styled } from "@mui/material/styles";
import SharedToolTip from "../../shared/sharedToolTip/SharedToolTip";
import Tooltip from "@mui/material/Tooltip";
import Clear from "@mui/icons-material/Clear";
import {
  StyledExpansionPanel,
  StyledExpansionPanelSummary,
} from "../../shared/ExpansionPanels/ExpansionPanel";

const StyledClear = styled(Clear)({
  color: "#102b4e",
});

const StyledTooltip = styled(Tooltip)({
  "& .MuiTooltip-popper": {
    opacity: 1,
    pointerEvents: "auto",
  },
  "& .MuiTooltip-tooltip": {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 350,
  },
});

function TradeIn({
                   customerReservation,
                   fromCrc,
                   user,
                   selectedMarket,
                   tradeInDetails,
                   t,
                   linkEnabled,
                   isOrderCancelled,
                   status,
                   ...restProps
                 }) {
  const [expandTradeInDetails, setExpandTradeInDetails] = useState(true);
  const [tradeInTooltipFlag, setTradeInTooltipFlag] = useState(false);
  const [mustAcceptPurchaseRequestTooltipFlag, setMustAcceptPurchaseRequestTooltipFlag] = useState(false);

  const expandCollapseAccordion = useCallback(() => {
    setExpandTradeInDetails(prev => !prev);
  }, []);

  const parseBoolean = useCallback((value) => {
    if (value === "false" || value === false) {
      return t("GeneralEMP.statusNo");
    } else if (value === "true" || value === true) {
      return t("GeneralEMP.statusYes");
    } else {
      return value;
    }
  }, [t]);

  const getTradeInType = useCallback((type) => {
    switch (type) {
      case FINANCED:
        return t("TradeIn.US.finance");
      case LEASED:
        return t("TradeIn.US.lease");
      case OWNED:
        return t("TradeIn.US.owned");
      default:
        return null;
    }
  }, [t]);

  const toggleToolTip = useCallback((tooltip, e) => {
    e && e.stopPropagation();

    switch (tooltip) {
      case "tradeInTooltipFlag":
        setTradeInTooltipFlag(prev => !prev);
        break;
      case "mustAcceptPurchaseRequestTooltipFlag":
        setMustAcceptPurchaseRequestTooltipFlag(prev => !prev);
        break;
      default:
        break;
    }
  }, []);

  const market = fromCrc && user.market !== "USA" && user.market !== "CAN"
    ? selectedMarket
    : user.market;

  const tradeInType = tradeInDetails && getTradeInType(tradeInDetails.ownershipType);

  let tradeInHeader = IS_USA_MARKET(market)
    ? t("TradeIn.US.header")
    : t("TradeIn.header");

  if (tradeInType) {
    tradeInHeader = `${tradeInHeader} - ${tradeInType}`;
  }

  const disableDealerActionsFlag = customerReservation?.purchaseInfo?.disableDealerActionsFlag;

  const tradeInAssessmentFlag = !tradeInDetails.dealerSubmitted && !tradeInDetails.tradeInExpired;

  return (
    <StyledExpansionPanel
      defaultExpanded={false}
      onChange={expandCollapseAccordion}
    >
      <StyledExpansionPanelSummary style={crStyles.headerBarBg}>
        <div className={sharedStyles.headerBar}>
          <div className={sharedStyles.header}>
            {tradeInHeader}
            {IS_USA_MARKET(market) && (
              <SharedToolTip
                openTestid="tradeInTooltipOpen"
                closeTestid="tradeInTooltipClose"
                open={tradeInTooltipFlag}
                closeTooltip={(e) => toggleToolTip("tradeInTooltipFlag", e)}
                openTooltip={(e) => toggleToolTip("tradeInTooltipFlag", e)}
                body={t("OrderDetailsConsumerDeposit.tradeInTooltipBody")}
              />
            )}
          </div>
          <div className={styles.acceptRejectDiv}>
            <HasPermissionTo
              perform={["tradeIn:write"]}
              permissions={user.permissions.rolePermissions}
              condition={
                IS_USA_MARKET(market) &&
                !tradeInDetails.dealerSubmitted &&
                !tradeInDetails.tradeInExpired &&
                tradeInType
              }
              render={() => {
                return linkEnabled ? (
                  <button
                    className={`${styles.acceptRejectButton} ${
                      tradeInAssessmentFlag && disableDealerActionsFlag
                        ? styles.disableDealerActionsAccept
                        : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    data-testid="accept-reject-trade-in"
                    disabled={tradeInAssessmentFlag && disableDealerActionsFlag}
                  >
                    {t("TradeIn.US.acceptRejectTradeIn")}
                  </button>
                ) : (
                  <StyledTooltip
                    placement="bottom-start"
                    open={mustAcceptPurchaseRequestTooltipFlag}
                    title={
                      <div>
                        <button
                          onClick={(e) =>
                            toggleToolTip("mustAcceptPurchaseRequestTooltipFlag", e)
                          }
                          className={styles.exitButton}
                        >
                          <StyledClear />
                        </button>
                        <div className={styles.bodyContent}>
                          {t("TradeIn.US.mustAcceptPurchaseRequestTooltipBody")}
                        </div>
                      </div>
                    }
                  >
                    <button
                      className={styles.disabledAcceptRejectButton}
                      data-testid="accept-reject-trade-in-disabled"
                      onClick={(e) =>
                        toggleToolTip("mustAcceptPurchaseRequestTooltipFlag", e)
                      }
                      disabled={tradeInAssessmentFlag && disableDealerActionsFlag}
                    >
                      {t("TradeIn.US.acceptRejectTradeIn")}
                    </button>
                  </StyledTooltip>
                );
              }}
            />
            {expandTradeInDetails ? (
              <ExpandMoreIcon data-testid="more" />
            ) : (
              <ExpandLessIcon data-testid="less" />
            )}
          </div>
        </div>
      </StyledExpansionPanelSummary>

      {isOrderCancelled(status) && (
        <div className={styles.overlay} data-testid="tradeInOverlay" />
      )}
      {ONLINE_TRADE_IN_MARKETS.includes(market) && (
        <OnlineTradeIn
          parseBoolean={parseBoolean}
          customerReservation={customerReservation}
          fromCrc={fromCrc}
          user={user}
          selectedMarket={selectedMarket}
          tradeInDetails={tradeInDetails}
          t={t}
          linkEnabled={linkEnabled}
          isOrderCancelled={isOrderCancelled}
          status={status}
          {...restProps}
        />
      )}
      {OFFLINE_TRADE_IN_MARKETS.includes(market) && (
        <OfflineTradeIn
          parseBoolean={parseBoolean}
          customerReservation={customerReservation}
          fromCrc={fromCrc}
          user={user}
          selectedMarket={selectedMarket}
          tradeInDetails={tradeInDetails}
          t={t}
          linkEnabled={linkEnabled}
          isOrderCancelled={isOrderCancelled}
          status={status}
          {...restProps}
        />
      )}
    </StyledExpansionPanel>
  );
}

export default withTranslation("emp")(TradeIn);
